export default __webpack_public_path__ + "static/media/ic_facebook.11e40494.svg";